import { lazy } from "react";

/**
 * Wraps React.lazy with a one-time auto-reload recovery.
 *
 * This mitigates blank screens caused by stale cached chunks after a new deploy
 * (e.g. "Importing a module script failed" / failed dynamic import).
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await importer();
    } catch (err) {
      const key = "__lazy_chunk_retry__";
      const hasRetried = sessionStorage.getItem(key) === "1";

      if (!hasRetried) {
        sessionStorage.setItem(key, "1");
        // Force a full reload to fetch the latest chunks.
        window.location.reload();
        // Keep the promise pending; page will reload.
        await new Promise(() => {});
      }

      // If we already retried, bubble the error so an ErrorBoundary (if any)
      // or the console can surface it.
      throw err;
    }
  });
}
